import { __read } from "tslib";
import * as u from './urx';
import { findMaxKeyValue } from './AATree';
import { domIOSystem } from './domIOSystem';
import { sizeSystem, hasGroups } from './sizeSystem';
export function groupCountsToIndicesAndCount(counts) {
    return counts.reduce(function (acc, groupCount) {
        acc.groupIndices.push(acc.totalCount);
        acc.totalCount += groupCount + 1;
        return acc;
    }, {
        totalCount: 0,
        groupIndices: [],
    });
}
export var groupedListSystem = u.system(function (_a) {
    var _b = __read(_a, 2), _c = _b[0], totalCount = _c.totalCount, groupIndices = _c.groupIndices, sizes = _c.sizes, _d = _b[1], scrollTop = _d.scrollTop, headerHeight = _d.headerHeight;
    var groupCounts = u.stream();
    var topItemsIndexes = u.stream();
    var groupIndicesAndCount = u.streamFromEmitter(u.pipe(groupCounts, u.map(groupCountsToIndicesAndCount)));
    u.connect(u.pipe(groupIndicesAndCount, u.map(function (value) { return value.totalCount; })), totalCount);
    u.connect(u.pipe(groupIndicesAndCount, u.map(function (value) { return value.groupIndices; })), groupIndices);
    u.connect(u.pipe(u.combineLatest(scrollTop, sizes, headerHeight), u.filter(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], sizes = _b[1];
        return hasGroups(sizes);
    }), u.map(function (_a) {
        var _b = __read(_a, 3), scrollTop = _b[0], state = _b[1], headerHeight = _b[2];
        return findMaxKeyValue(state.groupOffsetTree, Math.max(scrollTop - headerHeight, 0), 'v')[0];
    }), u.distinctUntilChanged(), u.map(function (index) { return [index]; })), topItemsIndexes);
    return { groupCounts: groupCounts, topItemsIndexes: topItemsIndexes };
}, u.tup(sizeSystem, domIOSystem));
